export default __webpack_public_path__ + "static/analytics_secondary_img-6878942d33303da8622f89a5574937d8.png";